import { Component, Inject } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TranslateService } from "@ngx-translate/core";
import { Clipboard } from "@angular/cdk/clipboard";

export interface AdminApiTokenRevealData {
  token: string;
}

/**
 * The backend hands the clear text token out once, on generation, and every later read comes back
 * obfuscated - closing this dialog loses the value for good.
 */
@Component({
  selector: "mh-admin-api-token-reveal",
  templateUrl: "./admin-api-token-reveal.component.html",
  styleUrls: ["./admin-api-token-reveal.component.less"],
})
export class AdminApiTokenRevealComponent {
  constructor(
    @Inject(NZ_MODAL_DATA) public modalData: AdminApiTokenRevealData,
    private modal: NzModalRef,
    private clipboard: Clipboard,
    private notificationService: NzNotificationService,
    private readonly translateService: TranslateService,
  ) {}

  copyToken(): void {
    if (this.clipboard.copy(this.modalData.token)) {
      this.notificationService.success("", this.translateService.instant("admin.api-tokens.copy.success"));
    } else {
      this.notificationService.error("", this.translateService.instant("notification.error"));
    }
  }

  onClose(): void {
    this.modal.close();
  }
}
